/**
 * Browser-Storage-Regeln des KeycloakAuthProviders (TQ #409, SPEC-Cockpit-pro-Kunde §4.1 a/b).
 *
 * Mehrere Cockpit-Instanzen teilen sich ein Origin (cockpit.it-sce.de/<kennung>/). Deshalb:
 *  - alle Schluessel mit Instanz-Praefix (`<kennung>:`), Default '' = bisheriges Verhalten;
 *  - OIDC-Tokens nie in localStorage: `accessTokenInLocalStorage: false` unterdrueckt die
 *    Legacy-Kopie `access_token` (keycloak-js haelt die Tokens ohnehin im Speicher; die
 *    One-Shot-Uebergaben Seed/Checkout liegen in sessionStorage).
 */
export interface AuthStorageOptions {
  keyPrefix?: string
  accessTokenInLocalStorage?: boolean
}

export const SEED_TOKENS_KEY = 'itsce_kc_seed_tokens'
export const CHECKOUT_TOKENS_KEY = 'itsce_kc_checkout_tokens'
export const LEGACY_ACCESS_TOKEN_KEY = 'access_token'

export function authStorageKey(opts: AuthStorageOptions, key: string): string {
  return `${opts.keyPrefix ?? ''}${key}`
}

/** Legacy-Kopie des Access-Tokens (nur wenn erlaubt; Pfad-Instanzen: nie). */
export function storeAccessToken(opts: AuthStorageOptions, token: string): void {
  if (opts.accessTokenInLocalStorage === false) return
  localStorage.setItem(authStorageKey(opts, LEGACY_ACCESS_TOKEN_KEY), token)
}

export function clearAccessToken(opts: AuthStorageOptions): void {
  if (opts.accessTokenInLocalStorage === false) return
  localStorage.removeItem(authStorageKey(opts, LEGACY_ACCESS_TOKEN_KEY))
}
